"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESOURCE_TYPES = void 0;
exports.RESOURCE_TYPES = ['form', 'report', 'page'];
//# sourceMappingURL=resource-types.js.map